export enum RelationUpdateMode {
  Active = 0,
  New = 1,
  Expired = 2,
  Manual = 3,
}

export const relationUpdateModeAsString = new Map([
  [RelationUpdateMode.Active, "Active"],
  [RelationUpdateMode.New, "New"],
  [RelationUpdateMode.Expired, "Expired"],
  [RelationUpdateMode.Manual, "Manual"],
]);
